import React from 'react';

export const FormInput = ({ label, name, type = 'text', placeholder, value, onChange, required = false, error }: {
    label: string;
    name: string;
    placeholder?: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    type?: string;
    required?: boolean;
    error?: string | null;
}) => {
    const errorClass = error ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-rose-500 focus:border-rose-500';

    return (
        <div>
            <label htmlFor={name} className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
            <input
                id={name} name={name} type={type} placeholder={placeholder}
                value={value} onChange={onChange} required={required}
                className={`w-full p-2 border rounded-md ${errorClass}`}
            />
            {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
        </div>
    );
};